import styled, { css } from 'vue-styled-components';

import theme from '@/config/theme';

const dropdownProps = {
  visible: Boolean,
};

export type DropdownProps = {
  visible: boolean;
};

export const Item = styled.li`
  list-style: none;
  padding-bottom: 20px;
  padding-top: 20px;

  &:first-of-type {
    padding-top: 0;
  }

  &:last-of-type {
    padding-bottom: 0;
  }

  &:not(:last-of-type) {
    border-bottom: 1px solid ${theme.colors.gray2};
  }
`;

export const Link = styled.a`
  align-items: center;
  color: ${theme.colors.gray6};
  display: flex;
  font-size: ${theme.font.sizes.p2};
  gap: ${theme.spacings.xsmall};

  &:hover {
    color: ${theme.colors.primaryLight};
  }

  svg {
    width: 35px;
  }
`;

export const Wrapper = styled('ul', dropdownProps)`
  ${({ visible }: DropdownProps) => css`
    background-color: ${theme.colors.white};
    border: 1px solid ${theme.colors.gray3};
    border-radius: ${theme.border.radius.xsmall};
    box-shadow: ${theme.shadow.lv2};
    padding: ${theme.spacings.xlarge};
    z-index: ${theme.layers.overlay};

    ${!visible && 'display: none'}
  `}
`;
